import React, { useEffect } from "react"
import useCartContext from "../context/CartContext"
import useProducts from "../context/ProductsContext"
import Loading from "./Loading"
import { useNavigate } from "react-router-dom"

const OrderSummary = () => {
  const navigate = useNavigate()
  const { cartItems } = useCartContext()
  const { products, isLoading } = useProducts()

  useEffect(() => {
    if (cartItems?.length <= 0) {
      navigate("/")
    }
  }, [cartItems?.length, navigate])

  const subtotal = cartItems.reduce((subtotal, item) => {
    return (
      (item.quantity * products?.find((p) => p.id === item.id).price || 0) +
      subtotal
    )
  }, 0)

  return (
    <div className="order-summary">
      {isLoading || cartItems?.length <= 0 ? (
        <Loading />
      ) : (
        <>
          <h4>Order summary</h4>
          <div className="order-summary-items-list cs-min">
            {cartItems.map((item) => (
              <div key={item.id} className="order-summary-item">
                <p>
                  {products?.find((p) => p.id === item.id).name || "unknown"}
                </p>
                <p className="flex-end">x{item.quantity}</p>
                <p className="flex-end">
                  ${products?.find((p) => p.id === item.id).price || 0}
                </p>
              </div>
            ))}
          </div>
          <div className="order-summary-items-list order-summary-price">
            <div className="order-summary-item order-summary-price-item">
              <p>Subtotal</p>
              <p className="flex-end">${subtotal}</p>
            </div>
            <div className="order-summary-item order-summary-price-item">
              <p>Shipping</p>
              <p className="flex-end">$10</p>
            </div>
            <div className="order-summary-item order-summary-price-item">
              <p>Taxes</p>
              <p className="flex-end">${(subtotal * 0.015).toFixed(2)}</p>
            </div>
            <div className="order-summary-item order-summary-price-item order-summary-price-total">
              <p>Total</p>
              <p className="flex-end">
                ${(subtotal + 10 + subtotal * 0.015).toFixed(2)}
              </p>
            </div>
          </div>
          <div className="order-summary-items-list  order-summary-price">
            <img src="/imgs/payment.png" alt="payment method" />
          </div>{" "}
        </>
      )}
    </div>
  )
}

export default OrderSummary
